import React, { useEffect, useMemo, useState } from "react";
import { db } from "../firebase/config";
import {
  collection,
  onSnapshot,
  orderBy,
  query
} from "firebase/firestore";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "../assets/AcunMedya-Logo.png";
import "./CalendarUser.css"; // ✅ YENİ
import { signOut } from "firebase/auth";
import { auth } from "../firebase/config"; // doğru path'e göre düzenle
import { useNavigate } from "react-router-dom";


const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
const ymd = (d) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;




const getProjectDisplayName = (name) => {
  if (name.includes("Survivor")) return "SURVIVOR";
  if (name.includes("Exatlon") || name.includes("Exathlon")) {
    return name.includes("Greece") ? "EXATHLON" : "EXATLON";
  }
  return name;
};

const exportFullCalendarPDF = async () => {
  const element = document.getElementById("calendarScrollX");
  if (!element) return alert("Takvim bulunamadı!");

  // 🔥 Orijinal stilleri kaydet
  const originalOverflow = element.style.overflow;
  const originalHeight = element.style.height;

  // 🔥 Full içeriği gösterecek şekilde genişlet
  element.style.overflow = "visible";
  element.style.height = `${element.scrollHeight}px`;

  // 🔥 Tam tabloyu resme dönüştür
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    scrollX: 0,
    scrollY: 0,
    width: element.scrollWidth,
    height: element.scrollHeight,
    windowWidth: element.scrollWidth,
    windowHeight: element.scrollHeight,
  });

  const imgData = canvas.toDataURL("image/png");

  // 📄 PDF oluştur
  const pdf = new jsPDF({
    orientation: "landscape",
    unit: "px",
    format: [canvas.width, canvas.height],
  });

  pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);

  // 📅 Dosya adı
  const now = new Date();
  const fileName = `CalendarView_${now.toISOString().replace(/[:.]/g, "-")}.pdf`;

  pdf.save(fileName);

  // ♻️ Element'i eski haline döndür
  element.style.overflow = originalOverflow;
  element.style.height = originalHeight;

  console.log("✅ Full takvim PDF olarak kaydedildi.");
};


export default function CalendarUser() {

  const [zones, setZones] = useState([]);

  const [hideHeader, setHideHeader] = useState(false);
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [viewMode, setViewMode] = useState("twoweeks");
  const [selectedProjectFilter, setSelectedProjectFilter] = useState("all");
  const [showLogo, setShowLogo] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    const q = query(collection(db, "zones"), orderBy("order", "asc"));

    const unsub = onSnapshot(q, (snap) => {
      setZones(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });

    return () => unsub();
  }, []);

  const getZoneColors = (zoneName) => {
    const zone = zones.find(z => z.name === zoneName);

    if (!zone || !zone.color) {
      return { bg: "#bbb", fg: "#111" }; // fallback
    }

    // Sarıysa koyu yazı
    const isYellow =
      zone.color.toUpperCase() === "#FFCE12" ||
      zone.color.toUpperCase() === "RGB(255,206,18)";

    return {
      bg: zone.color,
      fg: isYellow ? "#111" : "#fff"
    };
  };


  useEffect(() => {
    const handleScroll = () => {
      // Aşağı kayınca logo gizlensin
      if (window.scrollY > 80) setShowLogo(false);
      else setShowLogo(true);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 60) {
        setShowLogo(false); // kayınca gizle
      } else {
        setShowLogo(true); // yukarı dönünce göster
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);




  // Firestore listener
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "events"), (snap) => {
      setEvents(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);




  const days = useMemo(() => {
    const today = new Date();
    const start = new Date(today);
    const end = new Date(today);

    if (viewMode === "week") {
      start.setDate(today.getDate() - 1);
      end.setDate(today.getDate() + 7);
    } else {
      start.setDate(today.getDate() - 7);
      end.setDate(today.getDate() + 14);
    }

    const arr = [];
    const cursor = new Date(start);
    while (cursor <= end) {
      arr.push(new Date(cursor));
      cursor.setDate(cursor.getDate() + 1);
    }
    return arr;
  }, [viewMode]);

  useEffect(() => {
    const isMobile = () => window.innerWidth <= 768;
    if (!isMobile()) return;

    const scrollArea = document.querySelector("#calendarScrollX") || window;
    let lastScrollY = scrollArea === window ? window.scrollY : scrollArea.scrollTop;

    const updateTopGap = () => {
      const controls = document.querySelector(".calendar-controls-wrapper");
      const controlsBottom = controls?.getBoundingClientRect().bottom ?? 60;
      document.documentElement.style.setProperty("--top-gap", `${controlsBottom + 10}px`);
    };

    const handleScroll = () => {
      const currentScroll = scrollArea === window ? window.scrollY : scrollArea.scrollTop;

      if (currentScroll > lastScrollY && currentScroll > 50) {
        setHideHeader(true);
      } else if (currentScroll <= 10) {   // ✅ sadece en üste gelince geri gelsin
        setHideHeader(false);
      }

      lastScrollY = currentScroll;
      updateTopGap();   // ✅ kritik ekleme
    };

    scrollArea.addEventListener("scroll", handleScroll);
    return () => scrollArea.removeEventListener("scroll", handleScroll);
  }, []);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [projectList, setProjectList] = useState([]);
  useEffect(() => {
    const q = query(collection(db, "projects"), orderBy("order", "asc"));
    const unsub = onSnapshot(q, (snap) => {
      setProjectList(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);


  const isToday = (date) => {
    const today = new Date();
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    );
  };


  const inputDisabled = {
    width: "100%",
    marginTop: 4,
    padding: "6px 8px",
    borderRadius: 6,
    border: "1px solid #ccc",
    marginBottom: 10,
    background: "#f5f5f5",
    color: "#555",
  };

  return (
    <div
      style={{
        textAlign: "center",
        paddingBottom: 40,
        paddingTop: 0,
        background: "#f8f9fa",
        minHeight: "100vh",
        overflowY: "auto", // Masaüstü kayabilir
      }}
    >


      <div className={`calendar-header ${window.innerWidth < 768 ? "mobile" : "desktop"}`}>

        <img
          src={logo}
          alt="Acun Medya"
          className={`logo-fade ${hideHeader && window.innerWidth < 768 ? "hide" : ""}`}
        />

        <button
          className={`logout-modern ${hideHeader && window.innerWidth < 768 ? "hide" : ""}`}
          onClick={() => {
            signOut(auth)
              .then(() => navigate("/login"))
              .catch((err) => console.error("❌ Logout error:", err));
          }}
          title="Logout"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </button>

        <div className="calendar-buttons fixed-buttons">
          <button onClick={() => setViewMode("week")} className={viewMode === "week" ? "active" : ""}>1 WEEK</button>
          <button onClick={() => setViewMode("twoweeks")} className={viewMode === "twoweeks" ? "active" : ""}>3 WEEKS</button>
          <button onClick={exportFullCalendarPDF}>📄 EXPORT</button>
          <button onClick={() => navigate("/allevents")} className={viewMode === "events" ? "active" : ""}>EVENTS</button>
        </div>

      </div>






      {/* === TAKVİM === */}
      <div
        style={{
          position: "relative",
          borderRadius: 6,
        }}
      >
        <button
          onClick={() => {
            document.getElementById("calendarScrollX").scrollBy({
              left: -300,
              behavior: "smooth",
            });
          }}
          style={{
            position: "absolute",
            left: 5,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            background: "#343a40",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: 36,
            height: 36,
            cursor: "pointer",
            opacity: 0.8,
          }}
        >
          ◀
        </button>
        <div
          id="calendarScrollX"
          style={{
            overflow: "auto",
            height:
              window.innerWidth < 768
                ? "calc(100dvh - 60px)"   // ✅ Mobilde tam ekran, header gizlense bile sabit
                : "calc(100dvh - 120px)", // ✅ Desktop için tam ekran
            scrollBehavior: "smooth",
            borderRadius: 6,
            position: "relative",
          }}
        >



          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
              fontSize: 13,
              minWidth: 1000,
            }}
          >
            <thead style={{ position: "sticky", top: 0, zIndex: 10, background: "#000" }}>
              <tr>
                <th
                  style={{
                    position: "sticky",
                    left: 0,
                    top: 0,
                    background: "#000",
                    color: "#fff",
                    fontWeight: "900",
                    textTransform: "uppercase",
                    minWidth: 180,
                    zIndex: 6,
                    borderRight: "1px solid #999",
                    letterSpacing: "0.8px",
                    padding: 6,
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <span style={{ fontSize: 12 }}>PROJECT / DATE</span>
                    <select
                      value={selectedProjectFilter}
                      onChange={(e) => setSelectedProjectFilter(e.target.value)}
                      style={{
                        fontSize: 12,
                        padding: "3px 4px",
                        borderRadius: 4,
                        border: "1px solid #666",
                        background: "#000",
                        color: "#fff",
                        cursor: "pointer",
                      }}
                    >
                      <option value="all">All Projects</option>
                      <option value="Survivor">Survivor</option>
                      <option value="Exatlon">Exatlon</option>
                    </select>
                  </div>
                </th>

                {days.map((d) => {
                  const isSunday = d.getDay() === 0;
                  const today = isToday(d);

                  return (
                    <th
                      key={d}
                      style={{
                        background: today
                          ? "#dc3545"          // 🔴 TODAY
                          : isSunday
                            ? "#fff3cd"        // 🟡 SUNDAY
                            : "#000",
                        color: today ? "#fff" : isSunday ? "#000" : "#fff",
                        fontWeight: today ? 900 : 800,
                        border: today ? "2px solid #b02a37" : "1px solid #999",
                        minWidth: 140,
                        padding: "8px 4px",
                        textTransform: "uppercase",
                        letterSpacing: "0.3px",
                        position: "sticky",
                        top: 0,
                        zIndex: 5,
                      }}
                    >
                      {d.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" })}
                      <div style={{ fontSize: 11, opacity: 0.9 }}>
                        {d.toLocaleDateString("en-GB", { weekday: "short" }).toUpperCase()}
                      </div>

                      {today && (
                        <div style={{
                          fontSize: 10,
                          fontWeight: 700,
                          marginTop: 2,
                          letterSpacing: "0.5px"
                        }}>
                          TODAY
                        </div>
                      )}
                    </th>
                  );
                })}

              </tr>
            </thead>

            <tbody>
              {projectList.filter((proj) =>
                selectedProjectFilter === "all"
                  ? true
                  : proj.name
                    .toLowerCase()
                    .includes(selectedProjectFilter.toLowerCase())
              ).map((proj) => (
                <tr key={proj.name}>
                  <td
                    style={{
                      position: "sticky",
                      left: 0,
                      background: "#e9ecef",
                      borderRight: "1px solid #999",
                      minWidth: 130,
                      zIndex: 4,
                      textAlign: "center",
                      padding: "10px 6px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      <img
                        src={proj.flag}
                        alt={`${proj.name} flag`}
                        style={{
                          width: 50,
                          height: 50,
                          borderRadius: "50%",
                          boxShadow: "0 0 8px rgba(0,0,0,0.3)",
                          background: "#fff",
                        }}
                      />
                      <span
                        style={{
                          fontWeight: 800,
                          fontSize: 14,
                          color: "#000",
                          textTransform: "uppercase",
                        }}
                      >
                        {getProjectDisplayName(proj.name)}
                      </span>
                    </div>
                  </td>

                  {days.map((d) => {
                    const dateStr = ymd(d);
                    const todays = events
                      .filter(ev => ev.project === proj.name && ev.date === dateStr)
                      .sort((a, b) => {
                        // 🌞 DAY önce, 🌙 NIGHT sonra
                        if (a.timeOfDay !== b.timeOfDay) {
                          return a.timeOfDay === "DAY" ? -1 : 1;
                        }
                        // 🎮 Aynı timeOfDay ise gameOrder
                        return (a.gameOrder ?? 0) - (b.gameOrder ?? 0);
                      });


                    const isSunday = d.getDay() === 0;
                    const today = isToday(d);

                    return (
                      <td
                        key={proj.name + dateStr}
                        style={{
                          border: today ? "2px solid #dc3545" : "1px solid #ccc",
                          minWidth: 140,
                          height: 110,
                          verticalAlign: "top",
                          background: today
                            ? "rgba(220,53,69,0.08)"   // 🔴 TODAY (ilk seferdeki gibi)
                            : isSunday
                              ? "#fff3cd"              // 🟡 SUNDAY
                              : "#fff",
                        }}
                      >
                        {todays.map((ev) => {
                          const { bg, fg } = getZoneColors(ev.zone);

                          return (
                            <div
                              key={ev.id}
                              onClick={() => setSelectedEvent(ev)}
                              style={{
                                background: "#fff",
                                color: "#000",
                                borderRadius: 10,
                                boxShadow: "0 2px 5px rgba(0,0,0,0.25)",
                                marginBottom: 8,
                                overflow: "hidden",
                                cursor: "pointer",
                                border: ev.isReality
                                  ? "1.5px solid #ccc"
                                  : `2px solid ${bg}`,
                              }}
                            >
                              {ev.isReality ? (
                                <>
                                  {/* Üst siyah şerit */}
                                  <div style={{ background: "#000", height: 22 }}></div>

                                  {/* REALITY yazısı */}
                                  <div
                                    style={{
                                      background: "#fff",
                                      color: "#000",
                                      fontWeight: 800,
                                      fontSize: 16,
                                      padding: "8px 0",
                                      letterSpacing: "1px",
                                    }}
                                  >
                                    REALITY
                                  </div>

                                  {(ev.note || ev.endingCode) && (
                                    <div
                                      style={{
                                        fontSize: 11.5,
                                        marginTop: 2,
                                        fontStyle: "italic",
                                        opacity: 0.9,
                                        padding: "4px 8px",
                                      }}
                                    >
                                      {ev.note}
                                      {ev.endingCode && ` / ${ev.endingCode}`}
                                    </div>
                                  )}
                                </>
                              ) : (
                                <>
                                  <div
                                    style={{
                                      background: bg,
                                      color: fg,
                                      padding: "3px 6px",
                                      fontSize: 11,
                                      fontWeight: 800,
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    {ev.zone}
                                  </div>

                                  <div
                                    style={{
                                      fontSize: 10,
                                      fontWeight: 700,
                                      padding: "2px 6px",
                                      background: ev.timeOfDay === "NIGHT" ? "#343a40" : "#ffc107",
                                      color: ev.timeOfDay === "NIGHT" ? "#fff" : "#000",
                                      letterSpacing: "0.4px",
                                    }}
                                  >
                                    {ev.timeOfDay === "NIGHT" ? "🌙 NIGHT" : "🌞 DAY"} · {ev.gameOrder}. GAME
                                  </div>

                                  {ev.gameType && (
                                    <div
                                      style={{
                                        fontSize: 10,
                                        fontWeight: 800,
                                        padding: "2px 6px",
                                        background:
                                          ev.gameType === "IMMUNITY"
                                            ? "#198754"
                                            : ev.gameType === "REWARD"
                                              ? "#0d6efd"
                                              : "#6f42c1",
                                        color: "#fff",
                                        letterSpacing: "0.4px",
                                        textAlign: "center",
                                      }}
                                    >
                                      🎮 {ev.gameType}
                                    </div>
                                  )}


                                  <div style={{ padding: "6px 8px", fontSize: 12.5 }}>
                                    <div style={{ fontWeight: 700 }}>{ev.location}</div>
                                    <div style={{ fontSize: 12 }}>{ev.code}</div>
                                  </div>

                                  {(ev.note || ev.endingCode) && (
                                    <div
                                      style={{
                                        fontSize: 11,
                                        marginBottom: 6,
                                        opacity: 0.9,
                                        fontStyle: "italic",
                                      }}
                                    >
                                      {ev.note}
                                      {ev.endingCode && ` / ${ev.endingCode}`}
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          );
                        })}
                      </td>
                    );
                  })}

                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {selectedEvent && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.4)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 999,
            }}
          >
            <div
              style={{
                background: "#fff",
                padding: 20,
                borderRadius: 10,
                width: 400,
                boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
              }}
            >
              <h3 style={{ marginBottom: 10 }}>{selectedEvent.project}</h3>
              <p><b>Zone:</b> {selectedEvent.zone}</p>
              <p><b>Location:</b> {selectedEvent.location}</p>

              {/* 📅 Date */}
              <label><b>Date:</b></label>
              <input
                type="date"
                value={selectedEvent.date}
                disabled
                style={inputDisabled}
              />

              {/* 🕒 TIME OF DAY */}
              <label><b>Time of Day:</b></label>

              <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
                <div
                  style={{
                    flex: 1,
                    padding: "10px",
                    borderRadius: 8,
                    border: "1px solid #ccc",
                    background: selectedEvent.timeOfDay === "DAY" ? "#ffc107" : "#f1f1f1",
                    color: "#000",
                    fontWeight: 700,
                    textAlign: "center",
                    opacity: selectedEvent.timeOfDay === "DAY" ? 1 : 0.5,
                    cursor: "not-allowed",
                  }}
                >
                  🌞 DAY
                </div>

                <div
                  style={{
                    flex: 1,
                    padding: "10px",
                    borderRadius: 8,
                    border: "1px solid #ccc",
                    background: selectedEvent.timeOfDay === "NIGHT" ? "#343a40" : "#f1f1f1",
                    color: selectedEvent.timeOfDay === "NIGHT" ? "#fff" : "#000",
                    fontWeight: 700,
                    textAlign: "center",
                    opacity: selectedEvent.timeOfDay === "NIGHT" ? 1 : 0.5,
                    cursor: "not-allowed",
                  }}
                >
                  🌙 NIGHT
                </div>
              </div>
              <label><b>Game Type:</b></label>
              <input
                type="text"
                value={selectedEvent.gameType || ""}
                disabled
                style={inputDisabled}
              />

              {/* 🎮 GAME ORDER */}
              <label><b>Game Order:</b></label>

              <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                {[1, 2, 3].map((n) => (
                  <div
                    key={n}
                    style={{
                      flex: 1,
                      padding: "10px",
                      borderRadius: 8,
                      border: "1px solid #ccc",
                      background: selectedEvent.gameOrder === n ? "#0d6efd" : "#f1f1f1",
                      color: selectedEvent.gameOrder === n ? "#fff" : "#000",
                      fontWeight: 700,
                      textAlign: "center",
                      opacity: selectedEvent.gameOrder === n ? 1 : 0.5,
                      cursor: "not-allowed",
                    }}
                  >
                    {n}. GAME
                  </div>
                ))}
              </div>


              {/* 🎮 GAME CODE */}
              <label><b>Game Code:</b></label>
              <input
                type="text"
                value={selectedEvent.gameCode || selectedEvent.code || ""}
                disabled
                style={inputDisabled}
              />

              {/* 🔢 Ending Code */}
              <label><b>Ending Code:</b></label>
              <input
                type="text"
                value={selectedEvent.endingCode || ""}
                disabled
                style={inputDisabled}
              />

              {/* 📝 Note */}
              <label><b>Note:</b></label>
              <textarea
                value={selectedEvent.note || ""}
                disabled
                style={{
                  width: "100%",
                  height: 60,
                  resize: "none",
                  borderRadius: 6,
                  border: "1px solid #ccc",
                  marginTop: 4,
                  background: "#f5f5f5",
                  color: "#555",
                  padding: "6px 8px",
                }}
              />

              {/* 🔘 Only Close Button */}
              <div style={{ textAlign: "right", marginTop: 15 }}>
                <button
                  onClick={() => setSelectedEvent(null)}
                  style={{
                    background: "#6c757d",
                    color: "white",
                    border: "none",
                    borderRadius: 6,
                    padding: "6px 14px",
                    cursor: "pointer",
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}


        <button
          onClick={() => {
            document.getElementById("calendarScrollX").scrollBy({
              left: 300,
              behavior: "smooth",
            });
          }}
          style={{
            position: "absolute",
            right: 5,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            background: "#343a40",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: 36,
            height: 36,
            cursor: "pointer",
            opacity: 0.8,
          }}
        >
          ▶
        </button>
      </div>
    </div>
  );
}
